import React from 'react';
import { useSelector } from 'react-redux';
import format from 'date-fns/format';
import { Table, TableMobile, Icons } from '@components';
import { mdiCurrencyUsd, mdiCalendarRange } from '@mdi/js';

export const ResultadoVitalicio = ({ PercentualRCM, ResultadoSimulacao }) => {
  const custom = useSelector((state) => state.configs.tema);

  return (
    <>
      <div className="row">
        <div className="col-12 col-md-6 col-lg-4 mb-4">
          <div className="card h-100">
            <div className="card-body">
              <Icons
                path={mdiCalendarRange}
                color={custom.codCorLaranja}
                alt="File Icon"
                size={2}
              />
              <p className="text-muted ts-14 mt-2">Idade na aposentadoria</p>
              <h1 className="ts-20 fw-bold">
                {`${ResultadoSimulacao.IdadeAposentadoria} anos`}
              </h1>
              <p className="text-muted ts-14 mt-2">Data base para cálculo</p>
              <h1 className="ts-20 fw-bold">
                {format(new Date(), 'dd/MM/yyyy')}
              </h1>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-6 col-lg-4 mb-4">
          <div className="card h-100">
            <div className="card-body">
              <Icons
                path={mdiCurrencyUsd}
                color={custom.codCorLaranja}
                alt="File Icon"
                size={2}
              />
              <p className="text-muted ts-14 mt-2">
                Benefício atual (MAT % SC)
              </p>
              <h1 className="ts-20 fw-bold">
                {`R$ ${ResultadoSimulacao.ValorBeneficioAtualVitPerc}`}
              </h1>
              <p className="text-muted mt-2 ts-14">Saldo de conta acumulado</p>
              <h1 className="ts-20 fw-bold">
                {`R$ ${ResultadoSimulacao.ValorSaldoContaTotalProjetado}`}
              </h1>
            </div>
          </div>
        </div>
      </div>

      <Table
        className="is-desktop mb-4 ms-0"
        odd
        columns={[
          'Valor parcela vitalícia 0% RCM',
          'Percentual RCM',
          `Valor parcela vitalícia ${PercentualRCM}% RCM`,
        ]}
      >
        <tr>
          <td className="ts-14">{`R$ ${ResultadoSimulacao.ValorBeneficio}`}</td>
          <td className="ts-14">{`${PercentualRCM} %`}</td>
          <td className="ts-14">
            {`R$ ${ResultadoSimulacao.ValorBeneficioRcm}`}
          </td>
        </tr>
      </Table>
      <TableMobile className="mb-32">
        <div className="col-6">
          <div className="thead">Valor parcela vitalícia 0% RCM</div>
          <div className="td">{`R$ ${ResultadoSimulacao.ValorBeneficio}`}</div>
        </div>
        <div className="col-6">
          <div className="thead">Percentual RCM</div>
          <div className="td">{`${PercentualRCM} %`}</div>
        </div>
        <div className="col-6">
          <div className="thead">
            Valor parcela vitalícia {`${PercentualRCM} %`} RCM
          </div>
          <div className="td">{`R$ ${ResultadoSimulacao.ValorBeneficioRcm}`}</div>
        </div>
      </TableMobile>
    </>
  );
};
